
export type TBranchRecord = {
    id?: number;
    name: string;
    companyId: number;
    code: string;
    description?: string;
}

export const EmptyBranchRecord: TBranchRecord = {
    name: '',
    companyId: 0,
    code: '',
    description: '',
}

export type TBranch = {
    id: number;
    name: string;
    companyId: number;
    companyName: string;
    code: string;
}